import {
  OttPageTemplateComponent,
  PageTemplateComponentsType,
  UmpireComponent,
  UmpireComponentType,
} from '@tisa-group/models';

export class OttComponentsHelper {
  static readonly EVENTS_LIMIT = 18;

  static mapToCroppedComponents(
    components: UmpireComponent<UmpireComponentType>[] | PageTemplateComponentsType,
  ):
    | UmpireComponent<UmpireComponentType>[]
    | PageTemplateComponentsType
    | (OttPageTemplateComponent & any)[] {
    return components
      .sort((a, b) => a.index - b.index)
      .map(component => {
        const ottComponent = component as OttPageTemplateComponent;

        if (!ottComponent.events) {
          return component;
        }

        return {
          ...ottComponent,
          events: ottComponent.events.slice(0, this.EVENTS_LIMIT),
          itemsCropped: ottComponent.events.length >= this.EVENTS_LIMIT,
        };
      });
  }
}
